import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const ModalContainer = observer(() => {
    const store = useStore();
    const uiStore = useStoreUI();
    const show = uiStore.modal != null;
    const el = uiStore.modal?.el ?? null;
    const handleClose = () => {
        uiStore.modal = null;
    };

    const title = uiStore.modal?.title ?? '';
    const transcript = 'text';
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '20px' }}>{el}</Modal.Body>
            </Modal>
        </>
    );
});

export default ModalContainer;
